import React, { useState } from 'react';
import _includes from 'lodash/includes';
import _intersection from 'lodash/intersection';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Guest from '../Guest/Guest';

const GuestGroup = ({
  group,
  selectedGuests,
  draggingSeatInProgress,
  isFiltering,
  searchState,
  searchToken,
  onSelectGuest,
  onStartDrag,
  onEndDrag,
}) => {
  const { guests } = group;
  const isGroup = guests.length > 1;
  const [primaryHover, setPrimaryHover] = useState(false);
  const setGroupHover = bool => setPrimaryHover(bool);
  const guestIDs = guests.map(guest => guest.guest_view.id);
  const selectedCount = _intersection(guestIDs, selectedGuests).length;
  const canGroupHover = selectedCount === guestIDs || selectedCount === 0;
  const groupClassname = cx('sc__guest-list-group', { 'group--hovering': primaryHover });

  return (
    // TODO: update with 'guestRailUtils' to clean up group-filtering logic
    <div className={groupClassname}>
      {guests.filter((guest) => {
        // if group leader matches search token, show other group members
        if (isGroup && searchState) return group.guests[0].isVisible || guest.isVisible;
        return guest.isVisible;
      }).map((guest) => {
        const { id: guestID, relationship_type: relationshipType } = guest.guest_view;
        const isPrimary = relationshipType === 'PRIMARY' && isGroup;
        const isSelected = _includes(selectedGuests, guestID);
        const partOfDrag = isSelected && draggingSeatInProgress;

        return (
          <Guest
            key={`guest-${guestID}`}
            guest={guest}
            group={group}
            isCouple={false}
            isFiltering={isFiltering}
            isGroupPrimary={isPrimary && canGroupHover}
            isSelected={isSelected}
            partOfDrag={partOfDrag}
            searchState={searchState}
            searchToken={searchToken}
            onSelectGuest={onSelectGuest}
            onStartDrag={onStartDrag}
            onEndDrag={onEndDrag}
            setGroupHover={setGroupHover}
          />
        );
      })}
    </div>
  );
};

GuestGroup.propTypes = {
  draggingSeatInProgress: PropTypes.bool,
  isFiltering: PropTypes.bool,
  group: PropTypes.shape({
    guest_group_id: PropTypes.number,
    guests: PropTypes.arrayOf(PropTypes.shape({})),
    guest_affiliation: PropTypes.string,
  }),
  searchState: PropTypes.bool,
  searchToken: PropTypes.string,
  selectedGuests: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onSelectGuest: PropTypes.func,
  onStartDrag: PropTypes.func,
  onEndDrag: PropTypes.func,
};

export default GuestGroup;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/GuestGroup/GuestGroup.jsx